import { render, staticRenderFns } from "./rateList.vue?vue&type=template&id=50b3febd&scoped=true&"
import script from "./rateList.vue?vue&type=script&lang=js&"
export * from "./rateList.vue?vue&type=script&lang=js&"
import style0 from "./rateList.vue?vue&type=style&index=0&id=50b3febd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b3febd",
  null
  
)

export default component.exports